import * as React from "react";
import Modal from "../../ui/modal/Modal";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {JobInvoicePath, JobInvoicePathLabelEnum} from "../../../model/job/JobInvoicePath";

interface ComponentProps {
	/**
	 * Invoice path
	 */
	invoicePath: JobInvoicePath
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
}

interface State {
	/**
	 * If true, confirmation is checked and submit button is enabled.
	 */
	changeConfirmed: boolean;
}

type Props = ComponentProps;

export default class ConfirmChangePartnerBrandModal extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {changeConfirmed: false};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Confirm"} autoWidth={true}>
				<div style={{width: "500px"}}>
					<p>Are you sure you want to change invoice path?</p>
					<div style={{margin: "20px 0"}}>
						<Checkbox checked={this.state.changeConfirmed}
								  label={`I confirm ${JobInvoicePathLabelEnum[this.props.invoicePath]} is the correct invoice path for this Job`}
								  onChange={() => this.setState({changeConfirmed: !this.state.changeConfirmed})}/>
					</div>
					<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
					<div className={"pull-right"}>
						<ButtonPrimary label={"Proceed"} disabled={!this.state.changeConfirmed} onClick={this.props.onConfirm}/>
					</div>
				</div>
			</Modal>
		)
	}
}